import { memo } from 'react';

// ============= Component =============
/**
 * MobileRestrictionMessage Component
 * Simple message for mobile restrictions
 */
export const MobileRestrictionMessage = memo(() => (
  <div style={{ padding: '1rem' }}>
    <p>This workflow cannot be viewed on this device please use another</p>
  </div>
));

MobileRestrictionMessage.displayName = 'MobileRestrictionMessage';
